import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";

// LQC-3085 - rebuilt from both lists on every update so a live change can't be lost
// when the grid resets to the search results. Returns `historic` itself when no
// trade overlaps, so React skips the re-render.
export function overlayLiveTradesOnHistorical(
  historic: ExecutionStrategy[],
  live: (ExecutionStrategy | undefined)[] | undefined,
): ExecutionStrategy[] {
  if (!live || live.length == 0) return historic;

  const liveByEsid = new Map<string, ExecutionStrategy>();
  live.forEach((trade) => {
    if (trade?.esid) liveByEsid.set(trade.esid, trade);
  });

  let replaced = false;
  const rows = historic.map((trade) => {
    const liveTrade = liveByEsid.get(trade.esid);
    if (!liveTrade || liveTrade == trade) return trade;
    replaced = true;
    return liveTrade;
  });

  return replaced ? rows : historic;
}
